export default __webpack_public_path__ + "static/media/Capa.b3c6ab05.svg";